module.exports = __webpack_public_path__ + "static/img/1_1_5_2.ebabeef7.jpg";